import { Button } from "@miror-ui/components";
import { useRouter } from "next/router";
import { useFortuneTellerTelFortuneList } from "repositories/hooks";
import { PinkyRectangle } from "shared/components/atoms/PinkyRectangle";
import H4 from "shared/components/atoms/h4";
import { ListItem } from "shared/components/molecules/ListItem";
import {
  FortuneTeller,
  fortuneTellerTelFortuneListSortOrder,
} from "shared/types";
import tw from "twin.macro";
import { Paths } from "utils/routes";

interface Props {
  fortuneTeller: FortuneTeller;
  className?: string;
}

const listItemCss = {
  title: tw`font-base text-xs leading-[18px] tracking-[.35px]`,
  text: tw`font-base text-2xs leading-[10px] tracking-[.29px] text-theme text-left`,
};

export const TelFortuneRecommendation = ({
  fortuneTeller,
  className,
}: Props) => {
  const { push } = useRouter();
  const getFortuneTellerTelFortuneParams = {
    orderBy: fortuneTellerTelFortuneListSortOrder.salesQuantity,
    limit: 1,
  };
  const { telFortunes: telFortunes } = useFortuneTellerTelFortuneList(
    fortuneTeller?.id,
    getFortuneTellerTelFortuneParams
  );

  const handleClick = () => {
    push(Paths.telFortunes.show(telFortunes[0]?.id));
  };

  return telFortunes[0] ? (
    <PinkyRectangle tw="px-5 mx-[-20px]" className={className}>
      <H4>{fortuneTeller?.name}先生は電話鑑定がおすすめです✨</H4>
      <ListItem
        tw="rounded mt-[14px] bg-white px-[8px] py-[10px]"
        image={telFortunes[0]?.imageUrl}
        imageSize={52}
        title={telFortunes[0]?.title}
        text={`¥${telFortunes[0]?.costPerMinute}/分`}
        classes={listItemCss}
      />
      <Button tw="w-full mt-4" onClick={handleClick}>
        電話鑑定に進む
      </Button>
    </PinkyRectangle>
  ) : null;
};
